module.exports = __webpack_public_path__ + "48b31b2cc5500209ad71315a90a6d275.pdf";